import angular from 'angular';
import './exportbuilder.managelibrary.ctrls';
import './exportbuilder.managelibrary.resources';

angular.module('exportbuilder.managelibrary', [
    'exportbuilder.managelibrary.ctrls',
    'exportbuilder.managelibrary.resources'
]);